import { BankAccount } from './BankAccount.model';
import { APP_CONFIG } from '../../../config';
import { useApiGet } from '../../../api/api.hooks';

export function useBankAccounts(accountNumber: number) {
  return useApiGet<BankAccount[]>(APP_CONFIG.api.account.bankAccounts(accountNumber));
}
